import React from 'react';
import { Collapse } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

export default function Faqs({ faqData }) {
  if (!faqData || faqData.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400 font-medium">
        No questions found matching your search.
      </div>
    );
  }

  return (
    <Collapse
      accordion
      bordered={false}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: '#0f8269' }} />
      )}
      className="bg-transparent space-y-3"
    >
      {faqData.map((item, index) => (
        <Panel
          header={
            <span className="font-semibold text-gray-800 hover:text-[#0f8269] transition-colors">
              {item.question}
            </span>
          }
          key={`faq_${index}`}
          className="bg-slate-50 border border-slate-200/80 rounded-xl overflow-hidden shadow-sm"
        >
          <div
            className="text-gray-600 text-sm leading-relaxed pt-1 pb-2 pl-1"
            dangerouslySetInnerHTML={{ __html: item.answer }}
          />
        </Panel>
      ))}
    </Collapse>
  );
}